import Constants from "../../../AppConstants/Constants";
import { LANGUAGE_SET } from "../Constants";

export default function (state = Constants.DEFAULT_LANGUAGE, action) {
    const { payload, type } = action;

    switch (type) {
    case LANGUAGE_SET:
        return {
            languageId: payload.languageId,
            flag: payload.flagImageFileName.split(".")[0],
            code: payload.languageCulture
        };

    default:
        return state;
    }
}